import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {newsletterEmailPreview_template} from "./newsletterEmailPreview_template";

declare var ko: any;

export class newsletterInteractionEmailView_template extends vnTemplate {

    protected emailPreview: newsletterEmailPreview_template;

    protected getTemplateHtml(): string {
        return (`

            <div class="w-form w-form-large w-form-article-view">
                
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <div class="w-btn">
                         <button data-bind="event: { click: onClickEditNewsletterInteractionEmail }, visible: permissions()['newsletter_interaction_emails'].read" class="btn icon i-edit"  type="button">Edit Newsletter Interaction Email</button>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Info</strong>
                    </div>
                </div>
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group">
                             <dl class="double-list">
                                <dt>
                                    <span>Subject</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: subject"></span>
                                </dd>
                                <dt>
                                    <span>Preview Text</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: previewText"></span>
                                </dd>
                                <dt>
                                    <span>Event</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: event"></span>
                                </dd>
                                <dt>
                                    <span>Status</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: status"></span>
                                </dd>
                                <dt>
                                    <span>Schedule</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: schedule"></span>
                                </dd>
                                <dt>
                                    <span>Recipients</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: recipientSummary"></span>
                                </dd>
                                <dt>
                                    <span>Layout</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: mode"></span>
                                </dd>
                                <dt>
                                    <span>Template</span>
                                </dt>
                                <dd>
                                    <span data-bind="text: template"></span>
                                </dd>
                             </dl>
                         </div>
                    </div>
                </div>
                
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Content</strong>
                    </div>
                </div>
                
                <div class="w-form-body">
                   
                    <div class="form-body">
                        <div class="form-group form-group-content">
                            ${ this.emailPreview.getHtmlBuild() }
                         </div>
                    </div>
                    
                </div>
                
            </div>
        `);
    }

    protected initPartial(): void {
        this.emailPreview = new newsletterEmailPreview_template("newsletterEmailPreview", this.getTemplateViewModel(), this);
    }

    protected buildViewModel(): any {

        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            event: ko.observable(""),
            eventLabels: {},
            schedule: ko.observable(""),
            scheduleLabels: {},
            recipientLabels: {},
            segmentLabels: {},
            recipientSummary: ko.observable(""),
            status: ko.observable("Inactive"),
            mode: ko.observable(""),
            template: ko.observable(""),
            content: ko.observable(""),
            dateCreated: ko.observable(""),
            dateUpdated: ko.observable(""),
            permissions: ko.observableArray(this.initPermissions([ 'newsletter_interaction_emails'])),
            onClickEditNewsletterInteractionEmail: function (data, event) {
                self.onClickEditNewsletterInteractionEmail(data.id());
            },
            onClickCancel: function (data, event) {
                self.onClickCancel();
            },
        }
    }

    protected getTemplateName(): string {

        return "newsletterInteractionEmailView_template";
    }

    protected onClickEditNewsletterInteractionEmail(id: any): any {

        this.caller.onClickEditNewsletterInteractionEmail(id)
    }

    protected onClickCancel(): any {

        this.caller.onClickCancel()
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    public setEvents(events) {
        const labels = {};
        events.forEach((event) => labels[event.reference] = event.name);
        this.getTemplateViewModel().eventLabels = labels;
    }

    public setSchedules(schedules) {
        const labels = {};
        schedules.forEach((schedule) => labels[schedule.reference] = schedule.name);
        this.getTemplateViewModel().scheduleLabels = labels;
    }

    public setRecipients(recipients) {
        const labels = {};
        recipients.forEach((recipient) => labels[String(recipient.id)] = recipient.name);
        this.getTemplateViewModel().recipientLabels = labels;
    }

    public setSegments(segments) {
        const labels = {};
        segments.forEach((segment) => labels[String(segment.id)] = segment.title);
        this.getTemplateViewModel().segmentLabels = labels;
    }

    protected setNewsletterInteractionEmailData(newsletterInteractionEmail) {

        this.getTemplateViewModel().id(newsletterInteractionEmail.id);
        this.getTemplateViewModel().subject(newsletterInteractionEmail.subject);
        this.getTemplateViewModel().previewText(newsletterInteractionEmail.previewText);
        const eventReference = newsletterInteractionEmail.eventReference || '';
        this.getTemplateViewModel().event(this.getTemplateViewModel().eventLabels[eventReference] || eventReference);
        const scheduleReference = newsletterInteractionEmail.eventSchedule || 'immediately_after_event';
        this.getTemplateViewModel().schedule(this.getTemplateViewModel().scheduleLabels[scheduleReference] || scheduleReference);
        this.getTemplateViewModel().status(newsletterInteractionEmail.isActive ? 'Active' : 'Inactive');
        this.getTemplateViewModel().recipientSummary(this.getRecipientSummary(newsletterInteractionEmail));
        this.getTemplateViewModel().mode(newsletterInteractionEmail.mode || 'regular');
        this.getTemplateViewModel().template(newsletterInteractionEmail.template ? newsletterInteractionEmail.template.name : '');
        this.emailPreview.setHtml(newsletterInteractionEmail.eventContent || [newsletterInteractionEmail.content, newsletterInteractionEmail.signature]
            .filter((value) => !!value)
            .join('<br><br>'));
        this.getTemplateViewModel().dateCreated(newsletterInteractionEmail.dateCreated);
        this.getTemplateViewModel().dateUpdated(newsletterInteractionEmail.dateUpdated);
    }

    private getRecipientSummary(interactionEmail): string {
        let configuration = interactionEmail.recipientConfiguration || {};
        if (typeof configuration === 'string') {
            try {
                configuration = JSON.parse(configuration);
            } catch (error) {
                configuration = {};
            }
        }

        if (interactionEmail.recipientMode === 'mailingList') {
            const names = (configuration.mailingListIds || [])
                .map((id) => this.getTemplateViewModel().recipientLabels[String(id)] || ('Mailing List #' + id));
            return names.length ? 'Mailing List: ' + names.join(', ') : 'Mailing List';
        }

        if (interactionEmail.recipientMode === 'segment') {
            const names = (configuration.segmentIds || [])
                .map((id) => this.getTemplateViewModel().segmentLabels[String(id)] || ('Segment #' + id));
            return names.length ? 'Segment: ' + names.join(', ') : 'Segment';
        }

        const targeting = configuration.targeting || {};
        const groupCount = (targeting.filterGroups || []).length;
        const recipients = String(configuration.recipientEmails || '').trim();
        const details = [];
        if (recipients) {
            details.push(recipients);
        }
        if (groupCount) {
            details.push(groupCount + ' custom condition group' + (groupCount === 1 ? '' : 's'));
        }
        return details.length ? 'Custom: ' + details.join('; ') : 'Custom targeting';
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterInteractionEmailView_template.ts